export default "__VITE_ASSET__B0gA2Glc__"